import axiosInstance from "./axios";

const path = "common";


export const LogoutUser = async (data={}) => {
    return await axiosInstance(data).post(`${path}/logout`, data);
}